import React, { useState, useEffect, useContext } from "react";
import { nextDocument } from "react-doc-viewer/build/state/actions";
import {Link, NavLink, useHistory} from 'react-router-dom';
import { Button } from 'reactstrap';
import EventContext from "../../contexts/event";
import SocketClient from '../../helpers/connection';
import {gql, useMutation} from "@apollo/client";
import axios from "axios";
import {useIntl} from "react-intl";


//control panel for handeling the quiz
const PodiumControls: React.FC<{
  usersLength: number;
  presentationId?: string;
  answersLength: number;
  setStartTimer?: (arg0: boolean) => void;
  setResultPage?: (arg0: boolean) => void;
  mimicFormButtonClick?: () => void;
  nextQuestion?: () => void;
  answerId: string;
  noNext?: boolean;
  nextDisabled?: boolean;
  podium?: boolean;
  onBack?: boolean;
  quizQuestionIndex: number;
}> = ({ usersLength, answersLength, setResultPage, setStartTimer, presentationId, answerId, mimicFormButtonClick, nextQuestion, noNext = false, nextDisabled = false, onBack = false, podium = true,quizQuestionIndex=0 }) => {

  const eventContext = useContext(EventContext);
    const history = useHistory();
    const intl = useIntl();
    // @ts-ignore
    const [connectedUserCount, setConnectedUserCount] = useState(parseInt(localStorage.getItem('connected_users')));
    // @ts-ignore
    const [answeredUserCount, setAnsweredUserCount] = useState(parseInt(localStorage.getItem('answered_users')));

  useEffect(() => {
   configSocket();
 }, []);

 // configure socket connection and message recive
 function configSocket() {
   // socket get message callback
  SocketClient.getSocket().onclose = function(e) {
      console.log("socket Closed >>", e);
     configSocket();
   }
 }
    // update changes in database and push socket message to clients
    function updateAction(jsonData:any) {
        console.log("updateAction >>> ",jsonData)
        console.log("updateAction >>> ",`${process.env.REACT_APP_SOCKET_URL}/quiz-moderator-action-change`)

        const headers = {
            'Content-Type': 'application/json',
        }

        axios.post(`${process.env.REACT_APP_SOCKET_URL}/quiz-moderator-action-change`, jsonData, {
            headers: headers
        })
            .then((response) => {

                console.log("response", response)
            })
            .catch((error) => {
                console.log("error", error)
            })
    }

  return (
    <div className="quiz-controls">
      <div className="connected-users-answers">
        <div className="common"><span>{connectedUserCount}</span> {intl.formatMessage({ id: "quiz.connected" })}</div>
        <div className="seperator"></div>
        <div className="common"><span>{answeredUserCount}</span> {intl.formatMessage({ id: "quiz.answers" })}</div>
      </div>
      <div className="controls">
        {
          onBack && <Button   onClick={()=>{

                updateAction( {
                        presentationId: presentationId,
                        action: "back_question",
                        question_index:(quizQuestionIndex-1)
                    }
                );
                history.push(
                    `/${eventContext.slug}/${presentationId}/quiz-questions`,{'data':'back_press'}
                )

          }}  className="btn btn-next"> {intl.formatMessage({ id: "button.common.back" })} </Button>
        }

        {
          !noNext &&<Button  onClick={() => {
                localStorage.setItem('answered_users', '0');
                updateAction( {
                        presentationId: presentationId,
                        action: "next_question",
                        question_index:quizQuestionIndex
                    }
                );
                console.log("PAGE INDEX PODIUM Control",quizQuestionIndex)
               // SocketClient.sendMessage(`{"action":"sendMessage","message":"${presentationId}:next_question"}`);
                history.goBack();
            }} className={`btn ${nextDisabled ? 'noHover' : ''}  btn-next`}> {intl.formatMessage({ id: "quiz.next" })} <img src="/icons/quiz-next-ico.svg" alt="" /></Button>
        }

        {
          noNext && <Link to={`/${eventContext.slug}/${presentationId}/final-podium`}  onClick={() => {
                updateAction( {
                        presentationId: presentationId,
                        action: "final",
                        question_index:(quizQuestionIndex-1)
                    }
                );
                SocketClient.sendMessage(`{"action":"sendMessage","message":"${presentationId}:final"}`);
          }} className={`btn ${nextDisabled ? 'noHover' : ''}  btn-next`}>Final Podium<img src="/icons/quiz-next-ico.svg" alt="" /></Link>
      }
      </div>
    </div>
  )
}

export default PodiumControls;


